import { action } from 'satcheljs';
import type { ActionMessage } from 'satcheljs';

/**
 * Fired when the user finishes the Mirror reveal flow — either by reaching the
 * end or by skipping. Mail-layout listens for this to restore the folder pane
 * that the folder-pane onramp card collapsed when it launched the Mirror.
 */
export const onMirrorFlowCompleted: () => ActionMessage = action('onMirrorFlowCompleted');
